export default __webpack_public_path__ + "static/media/HorseCreek.12369d89.png";